/*eslint no-undef: "error"*/
import { Route, Navigate } from "react-router-dom";
import jwt_decode from "jwt-decode";

const CheckAuth = () => {
  const auth = localStorage.getItem("auth");
  var currentPath = window.location.pathname;
  if (auth !== "" && auth !== null) {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);

    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);
    const expiryDate = decoded.exp;
    const currentDateData = new Date();
    const currentDate = Date.parse(currentDateData);
    const currentDateString = currentDate / 1000;
    if (currentDateString > expiryDate) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("auth");
      localStorage.removeItem("customerData");
      localStorage.removeItem("workData");
      localStorage.removeItem("techData");
      localStorage.removeItem("jobCountData");
      localStorage.removeItem("siteID");
      localStorage.removeItem("unsyu");
      localStorage.removeItem("profiledata");
      localStorage.removeItem("permissions");
      <Route path="*" element={<Navigate to="/" replace />} />;
      // window.location.href ='/';
      // if(currentPath ==='/create-job' || currentPath ==='/my-work'){
      //   window.location = "/";
      // }
    } else {
      if (currentPath === "/") {
        const authToken = localStorage.getItem("auth");
        var decoded = jwt_decode(authToken);
        var userpermisson = decoded.user_permissions;

        var ApplicationPermissions = userpermisson[0].ApplicationPermissions;
        const filteredData = ApplicationPermissions.filter((obj) => {
          return obj.PermissionCode === "LOGIN_BG";
        });
        if (filteredData.length > 0) {
          if (filteredData[0].PermissionCode === "LOGIN_BG") {
            window.location = "/home";
          } else {
            <Route path="*" element={<Navigate to="/" replace />} />;
          }
        }
      }
    }
  } else {
    if (auth === "" || auth === null) {
      <Route path="*" element={<Navigate to="/" replace />} />;
    }
  }
};

export default CheckAuth;
